module.exports = "<div class=\"kan-service-logs-list\">\n    <!--<div class=\"kan-spinner-container\"-->\n         <!--*ngIf=\"loading\">-->\n        <!--<mat-spinner color=\"primary\"></mat-spinner>-->\n    <!--</div>-->\n    <kan-service-logs-list-item *ngFor=\"let log of logs\"\n                           [log]=\"log\"\n                           [searchText]=\"searchText\"\n                           (refresh)=\"emitRefresh()\">\n    </kan-service-logs-list-item>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/service-logs/list/component.html
// module id = ./src/modules/admin/components/service-logs/list/component.html
// module chunks = main